import React from 'react';

import { Column } from '@xingternal/xing-grid';

import { FixedBody } from '@/components/posting-header/components/body/components/fixed-body';
import Navigation from '@/components/posting-header/components/navigation';
import { JobPostingVisibleJobFragment } from '@/graphql/generated';
import { useBreakpoints, useLoginStates } from '@/hooks';

import { HeaderProps } from '../../header.types';
import { useStickyHeader } from '../../hooks';

import * as S from './sticky-header.styles';

const StickyHeaderContent: React.FC<{ job: JobPostingVisibleJobFragment }> = ({ job }) => (
  <>
    <Navigation job={job} />
    <FixedBody job={job} companyProfileUrl={job.companyInfo.company?.links?.public ?? undefined} />
  </>
);

export const StickyHeader: React.FC<HeaderProps & { width: number }> = ({ job, width }) => {
  const { isLoggedIn } = useLoginStates();

  const { isTopbarHidden } = useStickyHeader();

  const { isMobile } = useBreakpoints();

  return (
    <S.StyledStickyHeader
      $width={width}
      $isLoggedIn={isLoggedIn}
      data-testid="sticky-job-details-header"
      data-cy="sticky-job-details-header"
    >
      {isTopbarHidden ? (
        <StickyHeaderContent job={job} />
      ) : (
        <S.StickyHeaderMobileRow data-testid="sticky-job-details-header-mobile">
          <Column size={12}>{isMobile ? <S.StickyActionButtons isSticky /> : <StickyHeaderContent job={job} />}</Column>
        </S.StickyHeaderMobileRow>
      )}
    </S.StyledStickyHeader>
  );
};
